import React from 'react';
import { Row, Col, Form, Input } from 'antd';
import SelectProvince from './SelectProvince';
import SelectDistrict from './SelectDistrict';
import InputProvinceOther from './InputProvinceOther';
import InputDistrictOther from './InputDistrictOther';
import SelectHighSchool from './SelectHighSchool';
import InputHighSchoolOther from './InputHighSchoolOther';
import SelectWard from './SelectWard';

const FormHighSchool = React.memo(
  ({
    prefix,
    disabled,
    profileObj,
    provinces,
    wards,
    schools,
    resetFields,
    required = false,
  }) => {
    return (
      <Row gutter={16}>
        <Col xs={24} md={8}>
          <SelectProvince
            name={`province${prefix}`}
            required={required}
            options={provinces}
            disabled={disabled}
            onChange={(value) => {
              resetFields([
                `province${prefix}_other`,
                `ward${prefix}_other`,
                `highschool${prefix}_other`,
              ]);

              const updateValue = '';

              resetFields(
                [`ward${prefix}`, `highschool${prefix}`],
                updateValue,
              );
            }}
          />
          {/* {profileObj[`province${prefix}`] == '-1' && (
            <InputProvinceOther
              name={`province${prefix}_other`}
              disabled={disabled}
            />
          )} */}
        </Col>
        <Col xs={24} md={8}>
          <SelectWard
            name={`ward${prefix}`}
            required={required}
            options={wards}
            disabled={disabled}
            onChange={(value) => {
              resetFields([`ward${prefix}_other`, `highschool${prefix}_other`]);

              const updateValue = '';

              resetFields([`highschool${prefix}`], updateValue);
            }}
          />
          {/* {(profileObj[`province${prefix}`] == '-1' ||
            profileObj[`ward${prefix}`] == '-1') && (
            <InputDistrictOther
              name={`ward${prefix}_other`}
              disabled={disabled}
            />
          )} */}
        </Col>
        <Col xs={24} md={8}>
          {/* <SelectHighSchool
            name={`highschool${prefix}`}
            required={required}
            options={schools}
            disabled={disabled}
            onChange={(_) => resetFields([`highschool${prefix}_other`])}
          />
          {(profileObj[`province${prefix}`] == '-1' ||
            profileObj[`ward${prefix}`] == '-1' ||
            profileObj[`highschool${prefix}`] == '-1') && (
            <InputHighSchoolOther
              name={`highschool${prefix}_other`}
              disabled={disabled}
            />
          )} */}
          <Form.Item
            label={<span>Trường THPT</span>}
            name={`highschool${prefix}`}
            rules={[
              {
                required: required,
                message: 'Vui lòng nhập Trường THPT',
              },
            ]}
          >
            <Input
              className="border"
              disabled={disabled}
              // prefix={<EnvironmentOutlined className="site-form-item-icon" />}
            />
          </Form.Item>
        </Col>
      </Row>
    );
  },
);

export default FormHighSchool;
